import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ApiResponse } from '@core/models/common/api-response.model';
import { PaginatedApiResponse } from '@core/models/common/paginated-api-response.model';
import { MESSAGE_CONSTANT } from '../constants/message.constants';

@Injectable({ providedIn: 'root' })
export class ApiResponseHandler {
  static extractData<T>(response: ApiResponse<T> | PaginatedApiResponse<T>): T | T[] {
    if (!response || response.data === null || response.data === undefined) {
      throw new Error(MESSAGE_CONSTANT.API_RESPONSE_NULL);
    }

    if (ApiResponseHandler.isPaginated(response)) {
      return response.data.data as T[];
    }

    return response.data as T;
  }

  private static isPaginated<T>(
    response: ApiResponse<T> | PaginatedApiResponse<T>
  ): response is PaginatedApiResponse<T> {
    return (
      response.data !== null &&
      typeof response.data === 'object' &&
      'data' in response.data &&
      Array.isArray(response.data.data)
    );
  }

  static handleError(error: HttpErrorResponse): Observable<never> {
    const structuredError = {
      statusCode: error.status,
      message: error.error?.message ?? MESSAGE_CONSTANT.SOMETHING_WENT_WRONG,
      validationErrors: error.error?.errorBags ?? null,
    };

    return throwError(() => structuredError);
  }
}
